// extracted by mini-css-extract-plugin
module.exports = {"content":"FooterBottom_content__1VbKS","container":"FooterBottom_container__3K0n-","link":"FooterBottom_link__3SJYV"};